// ----------------------------------------------------------------------------- //
//  Internal dependencies
// ----------------------------------------------------------------------------- //
import detectInputHasValue from './app/detectInputHasValue';
import handleInputRangeChange from './app/handleInputRangeChange';
import handleInputNumberChange from './app/handleInputNumberChange';
import handleInputFileChange from './app/handleInputFileChange';
import loadVideoBackground from './app/loadVideoBackground';
import toggleBodyOverflow from './app/toggleBodyOverflow';
import setCollapsibleState from './app/setCollapsibleState';
import setDropdownState from './app/setDropdownState';
import decodeEncodedLinks from './app/decodeEncodedLinks';

// ----------------------------------------------------------------------------- //
// 	Modules
// ----------------------------------------------------------------------------- //
document.addEventListener( 'DOMContentLoaded', function() {

	detectInputHasValue();
	handleInputRangeChange();
	handleInputNumberChange();
	handleInputFileChange();
	loadVideoBackground();
	toggleBodyOverflow();
	setCollapsibleState();
	setDropdownState();
	decodeEncodedLinks();

});
